import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-avatar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "header-avatar__text" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "small-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.user?.image || '',
      alt: "Your avatar"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.user?.first_name) + " " + _toDisplayString(_ctx.user?.last_name), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.user?.roles?.[0]), 1 /* TEXT */)
    ])
  ]))
}